import * as React from 'react';
import * as $ from 'jquery';
import { SuperCriticalComponent, SuperCriticalReference } from 'lib/supercritical';
import 'lib/twitter-bootstrap-loader';

interface PCModalProps {
    shown : () => boolean;
    className? : string;
    children? : any;
    onBackDropClick? : () => void;
}

export class PCModal extends SuperCriticalComponent<PCModalProps> {
    modalref : (e : HTMLElement | null) => void;

    constructor(props : PCModalProps) {
        super(props);
        this.modalref = SuperCriticalReference(this,
            (props : PCModalProps, el : HTMLElement) => $(el).modal(props.shown() ? 'show' : 'hide'),
            el => {
                // No matter what, always hide modal when removing from DOM.
                // W/o this Bootstrap leaves the backdrop in the DOM. So if you, say, link to another
                // page from inside an open modal, you'll land on the new page w/ the backdrop still in
                // place and unable to be dismissed.
                // For testing if a modal is shown, see https://stackoverflow.com/a/21341587
                const modal = $(el).data('bs.modal');
                if (modal && modal.isShown) modal.hide();
            }
        );
    }

    srender(props : PCModalProps) : React.ReactElement<any> {
        return (
            <div className={'pcmodal modal fade ' + (props.className ? props.className : '')}
                role="dialog"
                data-backdrop="static"
                aria-hidden="true"
                ref={this.modalref}>
                <div className="modal-dialog">
                    {props.children}
                </div>
                <div className="backdrop-click-zone" onClick={props.onBackDropClick} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./apps/portcall/pcmodal/view.tsx